interface SEOSchemaProps {
  type: 'Organization' | 'WebSite' | 'WebPage' | 'Article' | 'FAQPage';
  data?: Record<string, unknown>;
}

export function SEOSchema({ type, data = {} }: SEOSchemaProps) {
  const schemas: Record<string, Record<string, unknown>> = {
    Organization: {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'AI风月',
      url: 'https://aifengyue.com',
      description: 'AI情感陪伴与风月互动体验平台，融合先进大语言模型，提供沉浸式风月情感对话、角色扮演与私密陪伴体验',
      foundingDate: '2025',
      ...data,
    },
    WebSite: {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'AI风月',
      url: 'https://aifengyue.com',
      description: 'AI情感陪伴与风月互动体验平台',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://aifengyue.com/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
      ...data,
    },
    WebPage: {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: 'AI风月',
      url: 'https://aifengyue.com',
      description: 'AI情感陪伴与风月互动体验平台',
      ...data,
    },
    Article: {
      '@context': 'https://schema.org',
      '@type': 'Article',
      publisher: {
        '@type': 'Organization',
        name: 'AI风月',
      },
      ...data,
    },
    FAQPage: {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      ...data,
    },
  };

  const schema = schemas[type];
  if (!schema) return null;

  return <script type="application/ld+json">{JSON.stringify(schema)}</script>;
}

export function HomeSchema() {
  return (
    <>
      <SEOSchema type="Organization" />
      <SEOSchema type="WebSite" />
      <SEOSchema type="WebPage" data={{
        name: 'AI风月 - 首页',
        url: 'https://aifengyue.com/',
        description: 'AI风月是专注AI情感陪伴与风月互动的智能平台，为用户提供沉浸式风月情感对话、角色扮演与私密陪伴体验',
      }} />
    </>
  );
}

export function CategorySchema({ name, description, url }: { name: string; description: string; url: string }) {
  return (
    <SEOSchema type="WebPage" data={{
      name: `${name} - AI风月`,
      url: `https://aifengyue.com${url}`,
      description,
    }} />
  );
}

export function ArticleSchema({ article }: { article: { title: string; excerpt: string; date: string; author: string; slug: string; tags: string[] } }) {
  return (
    <SEOSchema type="Article" data={{
      headline: article.title,
      description: article.excerpt,
      datePublished: article.date,
      author: {
        '@type': 'Person',
        name: article.author,
      },
      url: `https://aifengyue.com/article/${article.slug}`,
      keywords: article.tags.join(', '),
    }} />
  );
}